import store from "@/store/index"

export const verifyAuth = async(to, from, next) => {
    const user = store.state.user;
    const token = store.state.token
    if (to.name != 'auth-login' && (!user || !token)) {
        next({ name: 'auth-login' })
    } else next()
}